import React, {Fragment} from "react";

class FragmentEditor extends React.Component {

    focus = () => {
        //this.box.focus();
    }

    hide = () => {
        //this.box.hide();
    }

    render() {
        let children = null;
        if (this.props.children instanceof Function) {
            children = this.props.children({...this.props});
        } else {
           children = React.Children.map(this.props.children, child => {
               return <child.type {...this.props} {...child.props} >{child.props.children}</child.type>;
           });
        }
        return <Fragment>
            {children}
            {(!!this.props.footer || !!(this.props.buttons || []).length) && <div className="fragment-footer">
                <div className="center-block">
                    {this.props.footer}
                    {this.props.buttons}
                </div>
            </div>}
        </Fragment>;
    }

}

export const ChildFragmentEditor = (props) => <FragmentEditor>{props.children}</FragmentEditor>;

export default FragmentEditor;